<!--
 * @Author: liushumin
 * @Date: 2022-09-07 11:10:46
 * @LastEditTime: 2022-09-26 18:13:54
 * @LastEditors: liushumin
-->
<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
      <div class="szPlace">
        <p class="szTitle">生资下单</p>
        <div class="szPay">
          <img
            src="../../../assets/szOrder/icon_chenggong@2x.png"
            alt=""
          /><br />
          <h2>下单成功</h2>
          <br />
          <span>请来联系客户进行付款</span><br />
          <p>
            <el-button type="primary" @click="checkOrder">查看订单</el-button>
            <el-button @click="nextOrder">继续下单</el-button>
          </p>
        </div>
      </div>
    </div>
  </el-main>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    checkOrder() {
      this.$router.push({ path: "/szoperation/order/list" });
    },
    nextOrder() {
      this.$router.push({ path: "/szoperation/order/place" });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../../styles/order-global.scss";
.szTitle {
  font-size: 22px;
  font-weight: bold;
  color: #018388;
  padding-bottom: 18px;
  border-bottom: 1px solid #e9ebee;
}
.szPay {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 63vh;
}
.szPlace {
  height: 70.5vh;
}
.szPlace img {
  width: 108px;
  height: 108px;
  display: inline-block;
}
.szPlace h2 {
  font-size: 24px;
  font-weight: bold;
  color: #333333;
}
.szPlace span {
  font-size: 18px;
  color: #888888;
  margin-bottom: 8px;
}
::v-deep .szPlace .el-button--default {
  font-weight: 400 !important;
  color: #048489 !important;
  border: 1px solid #048489 !important;
}
</style>
